import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import images from "../../assets/images";
import { useTranslate } from "../../context/TranslationContext";
import { useGetAllTemplatesQuery } from "../../redux/Apis/Template";
import HeroSectionTemplateCard from "../cards/HeroSectionTemplateCard";
import OwlCarousel from "../carousel";
import SkeletonCourseCard from "./SkeletonCourseCard";

const TemplateSection = ({ showTemplateSection }) => {
  const { t } = useTranslate("templatebanner");
  const lang = useSelector((state) => state.language.lang);
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.authSlice);
  const {
    data: templateData,
    isLoading: isTemplateLoading,
    refetch: refetchTemplates,
  } = useGetAllTemplatesQuery(
    { featured: true, status: "approved", lang, page: 1, rowsPerPage: 7 },
    { refetchOnMountOrArgChange: true },
  );

  useEffect(() => {
    refetchTemplates();
  }, []);

  const featuredTemplates = templateData?.data || [];
  if (!showTemplateSection) return null;

  const handleClick = () => {
    if (!user) {
      toast.info("toast.loginRequiredCustom");
    }
    if (user?.role === "learner") {
      toast.info(t("toast.creatorRequiredCustom"));
    }
    if (user?.role === "creator" || user?.role === "both") {
      return navigate("/create-custom-template");
    }
  };

  return (
    <section
      className={`${
        (user && user.country) || localStorage?.getItem("selectedCountry")
          ? "banner"
          : "top-categories"
      }`}
    >
      <div className="container-fluid text-center">
        <h1 className="gallery-title mb-3 text-uppercase text-white">
          {t("title")}
        </h1>
        <p className="mb-4 p-lg l-grey-text">{t("subtitle")}</p>
        <button onClick={() => navigate("/template")} className="site-btn mb-5">
          {t("continueBtn")}
        </button>

        {isTemplateLoading ? (
          <SkeletonCourseCard length={7} />
        ) : (
          <OwlCarousel
            className="category-carousel"
            options={{
              loop: false,
              rewind: true,
              margin: 10,
              nav: true,
              dots: false,
              lazyLoad: true,
              autoplay: true,
              autoplayTimeout: 5000,
              autoplayHoverPause: true,
              smartSpeed: 500,
              navText: [
                '<i class="fas fa-angle-left"></i>',
                '<i class="fas fa-angle-right"></i>',
              ],
              responsive: {
                0: { items: 2, stagePadding: 0, autoplay: false },
                576: { items: 2, stagePadding: 20, autoplay: true },
                768: { items: 3, stagePadding: 0, autoplay: true },
                992: { items: 4, stagePadding: 0, autoplay: true },
                1200: { items: 5, stagePadding: 0, autoplay: true },
              },
            }}
          >
            {/* Custom Template Card */}
            <div className="template-card">
              <img
                src={images.home.template_default}
                alt={t("customtitle")}
                className="card-image"
              />
              <div className="card-body text-center mt-1">
                <p style={{ position: "relative", display: "inline-block" }}>
                  <i
                    className="fas fa-pen"
                    style={{ fontSize: "32px", color: "#6C2BD9" }}
                  ></i>
                  <i
                    className="fas fa-star"
                    style={{
                      color: "#6C2BD9",
                      position: "absolute",
                      top: "-5px",
                      left: "-8px",
                      fontSize: "14px",
                    }}
                  ></i>
                </p>
                <h5
                  className="card-title mb-1 text-truncate-2"
                  style={{ fontSize: "22px" }}
                >
                  {t("customtitle")}
                </h5>
                <p className="card-subtitle text-truncate-2">
                  {t("customsubtitle")}
                </p>
                <button
                  className="site-btn mt-sm-1 mt-lg-1"
                  onClick={handleClick}
                >
                  {t("custombtn")}
                </button>
              </div>
            </div>

            {featuredTemplates?.map((item, idx) => (
              <div key={idx} className="item px-2">
                <HeroSectionTemplateCard {...item} />
              </div>
            ))}
          </OwlCarousel>
        )}
      </div>
    </section>
  );
};

export default TemplateSection;
